"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeImplementInterfacesMenu = void 0;
const react_1 = __importStar(require("react"));
const index_1 = require("../../../DOM/index");
const index_2 = require("../../../../GraphQL/Resolve/index");
const graphql_zeus_1 = require("graphql-zeus");
const trees_1 = require("../../../../state/containers/trees");
const index_3 = require("../../components/index");
exports.NodeImplementInterfacesMenu = ({ node, hideMenu }) => {
    var _a;
    const { tree, setTree } = trees_1.useTreesState();
    const [menuSearchValue, setMenuSearchValue] = react_1.useState('');
    return (react_1.default.createElement(index_3.Menu, { onMouseEnter: () => {
            index_1.DOM.scrollLock = true;
        }, onMouseLeave: () => {
            index_1.DOM.scrollLock = false;
        }, onScroll: (e) => e.stopPropagation(), hideMenu: () => hideMenu() },
        react_1.default.createElement(index_3.MenuSearch, { value: menuSearchValue, onChange: setMenuSearchValue, onClear: () => setMenuSearchValue('') }),
        react_1.default.createElement(index_3.MenuScrollingArea, null, (_a = index_2.ResolveImplementInterface(node, tree.nodes)) === null || _a === void 0 ? void 0 : _a.sort((a, b) => (a.name > b.name ? 1 : -1)).filter((a) => { var _a; return !((_a = node.interfaces) === null || _a === void 0 ? void 0 : _a.includes(a.name)); }).filter((a) => a.name.toLowerCase().includes(menuSearchValue.toLowerCase())).map((f) => (react_1.default.createElement(index_3.MenuItem, { key: f.name, node: f, onClick: () => {
                var _a, _b;
                if (!node.interfaces) {
                    node.interfaces = [];
                }
                const interfacesToPush = [];
                const allInterfaces = tree.nodes.filter((ni) => ni.data.type === graphql_zeus_1.TypeDefinition.InterfaceTypeDefinition);
                const computeInterfaces = (interfaces) => {
                    interfacesToPush.push(...interfaces.filter((ii) => !interfacesToPush.includes(ii)));
                    for (const i of interfaces) {
                        const hasInterface = allInterfaces.find((interfaceObject) => interfaceObject.name === i);
                        if ((hasInterface === null || hasInterface === void 0 ? void 0 : hasInterface.interfaces) && hasInterface.interfaces.length) {
                            computeInterfaces(hasInterface.interfaces);
                        }
                    }
                };
                computeInterfaces([f.name]);
                node.interfaces.push(...interfacesToPush);
                const argsToPush = ((_a = f.args) === null || _a === void 0 ? void 0 : _a.filter((a) => { var _a; return !((_a = node.args) === null || _a === void 0 ? void 0 : _a.find((na) => na.name === a.name)); })) || [];
                node.args = (_b = node.args) === null || _b === void 0 ? void 0 : _b.concat(argsToPush);
                hideMenu();
                index_1.DOM.scrollLock = false;
                setTree(Object.assign({}, tree));
            } }))))));
};
